import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Coins, Sparkles } from "lucide-react";
import { CREDIT_PACKS } from "@/types/credit-pack";
import { useCreditPackPurchase } from "@/hooks/useCreditPackPurchase";

const CreditPackPurchase = () => {
  const { mutate: purchasePack, isPending } = useCreditPackPurchase();

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <Sparkles className="h-4 w-4" />
          Buy Credits
        </CardTitle>
        <CardDescription className="text-xs">
          Purchase credit packs to book more events
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        {CREDIT_PACKS.map((pack) => (
          <div
            key={pack.id}
            className="relative border rounded-lg p-3 hover:border-primary transition-colors"
          >
            {pack.popular && (
              <Badge variant="secondary" className="absolute -top-2 right-4">
                Most Popular
              </Badge>
            )}
            <div className="flex items-center justify-between gap-3">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <Coins className="h-4 w-4 text-primary shrink-0" />
                  <h3 className="font-semibold text-sm">{pack.credits} Credits</h3>
                </div>
                <p className="text-xs text-muted-foreground mb-1.5">
                  {pack.description}
                </p>
                <div className="flex items-center gap-2">
                  <span className="text-xl font-bold">£{pack.price}</span>
                  <Badge variant="secondary" className="text-xs">
                    Save {pack.savings}%
                  </Badge>
                </div>
              </div>
              <Button
                onClick={() => purchasePack(pack.id)}
                disabled={isPending}
                size="default"
                variant="secondary"
                className="shrink-0 self-center"
              >
                {isPending ? 'Processing...' : 'Purchase'}
              </Button>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default CreditPackPurchase;
